import { createStyles } from '@mantine/core';

export const useStyles = createStyles(
  (theme, props: { justify?: 'start' | 'end' | 'center' }, getRef) => ({
    optionIcon: {
      ref: getRef('icon'),
      flexShrink: 0,
    },
    option: {
      background: theme.white,
      borderColor: theme.colors.gray2[1],
      borderRadius: theme.radius.md,
      color: theme.colors.gray2[7],
      padding: `${theme.spacing.lg}px ${theme.spacing.lg}px`,
      height: '100%',
      width: '100%',
      wordWrap: 'normal',

      '&.isChecked': {
        borderColor: theme.colors.blue[7],
        background: `#4BEBE20D`,
      },

      '&.isDisabled': {
        opacity: 0.5,
        cursor: 'not-allowed',
      },
      '& .mantine-Button-inner': {
        justifyContent: props.justify || 'flex-start',
      },

      '@media (hover: hover)': {
        '&:not(.isChecked)': {
          '&:hover': {
            borderColor: theme.colors.blue[7],
            background: 'white',
          },
        },
      },

      '&.recommendedBadge': {
        border: '1px solid #B47E11',
      },
    },
    recommended: {
      color: theme.white,
      position: 'absolute',
      right: -1,
      top: 0,
      background: 'linear-gradient(268.28deg, #B47E11 0%, #DBB54D 30.86%, #B47E11 100%)',
      borderRadius: `0 ${theme.radius.md}px 0 ${theme.radius.md}px`,
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '4px 8px',
    },
    optionInput: {
      display: 'none',
    },

    container: {
      position: 'relative',
    },
    label: {
      whiteSpace: 'initial',
      lineHeight: '20px',

      '& a': {
        color: theme.colors.blue[7],
        textDecoration: 'none',

        '&:hover': {
          textDecoration: 'underline',
        },
      },
    },
    comingSoonPrefix: {
      fontStyle: 'italic',
    },
    badge: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: theme.spacing.xl,
      height: theme.spacing.xl,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: theme.colors.gray[7],
      borderRadius: `0 ${theme.radius.sm}px 0 ${theme.radius.sm}px`,
    },
    viewAll: {
      width: '100%',
      fontSize: theme.fontSizes.sm,
      color: '#1BC4CF',
    },

    badgeIcon: {},
  })
);
